var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Integration" },
    [
      _vm._l(_vm.categorizedLicenseList, function (items, category) {
        return _c("div", { key: category }, [
          _c("div", { staticClass: "integration-title" }, [
            _c("h2", { staticClass: "title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(`Extension.${items[0].licenseCategoryTranslationKey}`)
                )
              ),
            ]),
            _c("div", { staticClass: "divider" }),
          ]),
          _c(
            "div",
            { staticClass: "Box-container" },
            _vm._l(items, function (item) {
              return _c(
                "div",
                { key: item.licenseId, staticClass: "items" },
                [
                  _c("div", { staticClass: "item-title" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(`Extension.${item.licenseTranslationKey}_name`)
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "box-header-right" },
                      [
                        item.isLicenseExist
                          ? _c("div", { staticClass: "label m-right-15" }, [
                              _vm._v(_vm._s(_vm.$t("Integration.installed"))),
                            ])
                          : _vm._e(),
                        _c(
                          "Button",
                          {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: () => _vm.closePopup(item),
                                expression: "() => closePopup(item)",
                              },
                            ],
                            staticClass: "m-bottom-10 action-button",
                            attrs: { clearVariant: true },
                            on: {
                              click: function ($event) {
                                return _vm.openPopup(item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v("..."),
                              _c(
                                "div",
                                {
                                  staticClass: "action-popup",
                                  class: item.showActionBar
                                    ? "openActions"
                                    : "closeActions",
                                },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: {
                                        variant:
                                          "Boxlist-action Boxlist-action-edit",
                                        id: `btn-integration-overview-${item.licenseTranslationKey}`,
                                        iconName: "icon-login-eye",
                                        iconClass: "icon-login-eye",
                                        clearVariant: true,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateOverview(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "m-left-10" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("Integration.overview"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                  item.integrationProductId &&
                                  item.licenseCategoryTranslationKey !==
                                    "BesinDegerleri" &&
                                  item.licenseTranslationKey !== "Sube" &&
                                  item.licenseTranslationKey !== "TCMB" &&
                                  item.licenseTranslationKey !== "E-Arsiv" &&
                                  item.licenseTranslationKey !==
                                    "InventoryPortal" &&
                                  item.licenseTranslationKey !== "SimpraQuick"
                                    ? _c(
                                        "Button",
                                        {
                                          attrs: {
                                            variant:
                                              "Boxlist-action Boxlist-action-edit",
                                            id: `btn-integration-settings-${item.licenseTranslationKey}`,
                                            iconName: "icon-global-settings",
                                            iconClass: "icon-global-settings",
                                            clearVariant: true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goToPage(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "m-left-10" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Integration.configuration"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "box-content" }, [
                    _c("img", {
                      staticClass: "item_img",
                      attrs: {
                        src: item.image
                          ? `data:image/png;base64,${item.image}`
                          : `/static/images/simpra_extension.png`,
                      },
                    }),
                    _c("span", { staticClass: "m-left-10 m-right-10" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getShortDesc(
                            _vm.$t(
                              `Extension.${item.licenseTranslationKey}_desc`
                            )
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "Modal",
                    {
                      attrs: { isOpen: item.isModalActive },
                      on: {
                        closeModal: function ($event) {
                          return _vm.closeOverview(item)
                        },
                      },
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v(_vm._s(item.licenseName)),
                      ]),
                      _c("template", { slot: "content" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                `Extension.${item.licenseTranslationKey}_desc`
                              )
                            )
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            0
          ),
        ])
      }),
      _c("router-view", { key: _vm.$route.fullPath }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }